import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';


const HomeCourse = () => {
    return (
            <div className="rn-splite-style">
                <div className="split-wrapper">
                        <div className="row no-gutters radius-10 align-items-center">
                            <div className="col-lg-12 col-xl-6 col-12">
                                <div className="thumbnail image-left-content">
                                    <img src="./images/course.jpg" alt="split Images" />
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-6 col-12">
                                <div className="split-inner">
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <h4 className="title">Digital Course Outcomes:</h4>
                                    </ScrollAnimation>
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                    <p className="description"></p>
                                    </ScrollAnimation>

                                    
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <ol className="">
                                            <li>Eliminate 90% of bad money habits and poor financial decisions</li>
                                            <li>2X–5X your closing rate with battle-tested sales techniques.</li>
                                            <li>Learn 6 steps sales persuasion frameworks used by top sales pros to close 10x more sales. </li>
                                            <li>Boost revenue by up to 300% using structured sales funnels, buying stage understanding, objection handling and follow-ups</li>
                                            <li>Get clear on your career path in less than 7 days</li>
                                            <li>Land your next high-paying job or project in 30–60 days with confidence</li>
                                        </ol>
                                    </ScrollAnimation>
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <div className="view-more-button mt--35">
                                            <Link className="btn-default" to="/course">SEE MORE</Link>
                                        </div>
                                    </ScrollAnimation>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default HomeCourse
